import styled from '@emotion/styled'

export const RaceEventsContainerStyled = styled('div')({
  padding: '0rem 0rem 0.5rem',
})
